// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addDoc {
  margin-left: 15%;
}

.containerrr {
  display: flex;
}

.noteModifier {
  display: flex;
  flex-direction: column;
}

.general {
  display: flex;
  margin-top: 4%;
  margin-left: 22%;
}

.LabelInput {
  margin-left: 2%;
}

.infoColumn {
  display: flex;
  flex-direction: column;
  margin-top: 4%;
}

.infoColumnSpacing {
  margin-top: 1%;
  font-size: 17px;
}

.addDocFormInput {
  margin-left: 1%;
}

.addDocForm {
  display: flex;
}

.docRevoir {
  margin-top: 5%;
}

.nameStatus {
  display: flex;
}

.status {
  margin-left: 75%;
  font-size: 25px;
}

.uncomplete {
  margin-left: 55%;
  font-size: 25px;
  background-color: rgba(255, 149, 0, 0.05);
  color: orange;
  padding: 5px;
  border-radius: 5px;
}

.lateStatus {
  margin-left: 55%;
  font-size: 25px;
  background-color: rgba(255, 0, 0, 0.05);
  color: crimson;
  padding: 5px;
  border-radius: 5px;
}

.complete {
  margin-left: 55%;
  font-size: 25px;
  background-color: rgba(85, 235, 44, 0.255);
  color: green;
  padding: 5px;
  border-radius: 5px;
}

.toNotify {
  margin-left: 55%;
  font-size: 25px;
  background-color: rgba(255, 0, 0, 0.05);
  color: crimson;
  padding: 5px;
  border-radius: 5px;
}

.toRev {
  margin-left: 55%;
  font-size: 25px;
  background-color: rgba(44, 124, 235, 0.255);
  color: blue;
  padding: 5px;
  border-radius: 5px;
}

.display {
  display: flex;
}

.formDate {
  margin-left: 10%;
}`, "",{"version":3,"sources":["webpack://./src/pages/clientProfile/FakeIndi.scss"],"names":[],"mappings":"AAAA;EAEE,gBAAA;AAAF;;AAGA;EACI,aAAA;AAAJ;;AAIA;EACI,aAAA;EACA,sBAAA;AADJ;;AAMA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;AAHJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,aAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AAHJ;;AAOA;EACI,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAJJ;;AAQA;EACI,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AALJ;;AAQA;EACI,gBAAA;EACA,eAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AALJ;;AAQA;EACI,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AALJ;;AAUA;EACI,aAAA;AAPJ;;AAWA;EACI,gBAAA;AARJ","sourcesContent":[".addDoc{\n    \n  margin-left: 15%;\n}\n\n.containerrr{\n    display: flex;\n \n}\n\n.noteModifier{\n    display: flex;\n    flex-direction: column;\n}\n\n\n\n.general{\n    display: flex;\n    margin-top: 4%;\n    margin-left: 22%;\n}\n.LabelInput{\n    margin-left: 2%;\n}\n\n.infoColumn{\n    display: flex;\n    flex-direction: column;\n    margin-top: 4%;\n}\n\n.infoColumnSpacing{\n    margin-top: 1%;\n    font-size: 17px;\n}\n\n.addDocFormInput{\n    margin-left: 1%;\n}\n\n.addDocForm{\n    display: flex;\n   \n}\n\n.docRevoir{\n    margin-top: 5%;\n}\n\n.nameStatus{\n    display: flex;\n}\n\n.status{\n    margin-left: 75%;\n    font-size: 25px;\n\n}\n.uncomplete{\n    margin-left: 55%;\n    font-size: 25px;\n    background-color: rgba(255, 149, 0, 0.05);\n    color: orange;\n    padding: 5px;\n    border-radius: 5px;\n\n}\n\n.lateStatus{\n    margin-left: 55%;\n    font-size: 25px;\n    background-color: rgba(255, 0, 0, 0.05);\n    color: crimson;\n    padding: 5px;\n    border-radius: 5px;\n\n}\n\n.complete{\n    margin-left: 55%;\n    font-size: 25px;\n    background-color: rgba(85, 235, 44, 0.255);\n    color: green;\n    padding: 5px;\n    border-radius: 5px;\n\n}\n.toNotify{\n    margin-left: 55%;\n    font-size: 25px;\n    background-color: rgba(255, 0, 0, 0.05);\n    color: crimson;\n    padding: 5px;\n    border-radius: 5px;\n\n}\n.toRev{\n    margin-left: 55%;\n    font-size: 25px;\n    background-color: rgba(44, 124, 235, 0.255);\n    color: blue;\n    padding: 5px;\n    border-radius: 5px;\n\n}\n\n\n.display {\n    display: flex;\n \n}\n\n.formDate{\n    margin-left: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
